import * as Yup from "yup";
import { webServiceRequiredErrorMessage } from "panel/src/utils/validationMessage";

const Schema = Yup.object().shape({
  csvFileName: Yup.string().required(webServiceRequiredErrorMessage),
});

export default Schema;
